import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon, Share08Icon } from "@hugeicons/core-free-icons";
import { AppHeader } from "@/ui/layout/app-header";
import { Button } from "@/ui/components/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/ui/components/tooltip";
import { cn } from "@/lib/utils";
import { useForwarding } from "./forwarding";
import { useSearchMenu } from "./search-provider";

const shortcutLabel =
  typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform) ? "⌘ K" : "Ctrl K";

function SearchPill() {
  const { setOpen } = useSearchMenu();
  return (
    <button
      type="button"
      aria-keyshortcuts="Meta+K Control+K"
      onClick={() => setOpen(true)}
      className="group flex h-10 w-[300px] items-center gap-2.5 rounded-full bg-secondary px-3.5 text-[13px] text-muted-foreground shadow-[0_0_0_1px_var(--hairline)] transition-[box-shadow,color] duration-200 hover:text-foreground hover:shadow-[0_0_0_1px_var(--border)]"
    >
      <HugeiconsIcon icon={Search01Icon} strokeWidth={1.8} aria-hidden="true" className="size-[18px] shrink-0" />
      <span className="truncate">Search or jump to…</span>
      <kbd className="pointer-events-none ms-auto hidden h-6 items-center rounded-md bg-background px-1.5 font-sans text-[11px] text-muted-foreground shadow-[inset_0_-1px_0_var(--hairline)] select-none sm:flex">
        {shortcutLabel}
      </kbd>
    </button>
  );
}

function ForwardingIcon() {
  const { forwarding } = useForwarding();
  const dot = { positive: "bg-positive", warning: "bg-warning", faint: "bg-muted-foreground", destructive: "bg-destructive", neutral: "bg-foreground" }[forwarding.tone];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={`Forwarding: ${forwarding.label}`}
          className="relative grid size-10 place-items-center text-muted-foreground"
        >
          <HugeiconsIcon icon={Share08Icon} strokeWidth={1.8} className="size-[18px]" />
          <span className={cn("absolute top-2.5 right-2.5 size-2 rounded-full ring-2 ring-background", dot)} />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        Forwarding: {forwarding.label}
      </TooltipContent>
    </Tooltip>
  );
}

export function AppHeaderBar({ current, trail }: { current?: string; trail?: React.ReactNode }) {
  const { setOpen } = useSearchMenu();
  return (
    <AppHeader
      current={current}
      trail={trail}
      center={<SearchPill />}
      end={
        <div className="flex items-center gap-1.5">
          <Button variant="ghost" size="icon" className="md:hidden" aria-label="Search" onClick={() => setOpen(true)}>
            <HugeiconsIcon icon={Search01Icon} strokeWidth={1.8} />
          </Button>
          <ForwardingIcon />
        </div>
      }
    />
  );
}
